import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AppService } from './app-service';
import { Observable } from 'rxjs';
import { Quote } from './quote.service';

@Injectable({
    providedIn: 'root',
})
export class EmailService {
    constructor(private http: HttpClient, private appService: AppService) {}

    public getQuoteEmailText(
        quote: Quote,
        language: string,
        country: string,
        usecase: string
    ): Observable<{ text: string }> {
        return this.http.get<{ text: string }>(`${this.baseUrl(quote.id, quote.isLegacy)}/mail-text`, {
            params: {
                language,
                country,
                usecase,
            },
        });
    }

    public sendQuoteViaEmail(id: string, payload: object, isLegacy: boolean) {
        return this.http.post(`${this.baseUrl(id, isLegacy)}/mail`, payload);
    }

    public sendFeedback(sender: string, subject: string, message: string) {
        return this.sendEmail(sender, subject, message, 'feedback');
    }

    public sendIndividualOfferRequestEmail(sender: string, subject: string, message: string, type = 'maintenance') {
        return this.sendEmail(sender, subject, message, type);
    }

    private baseUrl(id: string, isLegacy: boolean) {
        return isLegacy
            ? `${environment.http.apiBaseUrl}quote/${id}/revision/0`
            : `${environment.http.quotation}quotations/service-configurator/quotes/${id}`;
    }

    private sendEmail(sender: string, subject: string, message: string, type: string) {
        const salesOrg = this.appService.getSalesOrg();
        const payload = {
            feedbackType: type,
            sender,
            subject,
            message,
            salesOrg,
        };
        return this.http.post(`${environment.http.apiBaseUrl}feedback`, payload);
    }
}
